import { RequestAction } from '@redux-requests/core'
import { UserSettings } from '../../../pages/Account/Account'
import { Company, Product } from '../../../pages/DashBoard/DashBoardScreen'
import { User } from '../auth/auth.types'

export const FETCH_ALL_PRODUCT_DATA = 'FETCH_ALL_PRODUCT_DATA'
export const FETCH_DOCUMENT = 'FETCH_DOCUMENT'
export const FETCH_DOCUMENT2 = 'FETCH_DOCUMENT2'
export const FETCH_MOVING_AVERAGES = 'FETCH_MOVING_AVERAGES'
export const FETCH_USER_AVERAGES = 'FETCH_USER_AVERAGES'
export const FETCH_GOVSTATS = 'FETCH_GOVSTATS'
export const FETCH_DETAILED_DATA = 'FETCH_DETAILED_DATA'
export const FETCH_DETAILED_DATA_NEW = 'FETCH_DETAILED_DATA_NEW'
export const FETCH_SUMMARY_DATA = 'FETCH_SUMMARY_DATA'
export const FETCH_LINECHART_DATA = 'FETCH_LINECHART_DATA'
export const FETCH_ALL_PRODUCT_DATA_BY_USER = 'FETCH_ALL_PRODUCT_DATA_BY_USER'
export const POST_PDF = 'POST_PDF'
export const POST_AND_UPDATE = 'POST_AND_UPDATE'
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT'
export const FETCH_METADATA = 'FETCH_METADATA'
export const DOCUMENT_RECEIVED = 'DOCUMENT_RECEIVED'
export const CREATE_DOCUMENT = 'CREATE_DOCUMENT'
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT'
export const ADD_WHITELIST_ITEM = 'ADD_WHITELIST_ITEM'
export const DELETE_WHITELIST_ITEM = 'DELETE_WHITELIST_ITEM'
export const FETCH_DISCARDED = 'FETCH_DISCARDED'
export const SET_CUSTOM_FILTER = 'SET_CUSTOM_FILTER'
export const GET_CUSTOM_FILTERS = 'GET_CUSTOM_FILTERS'
export const DELETE_CUSTOM_FILTER = 'DELETE_CUSTOM_FILTER'
export const FETCH_ALL_DISCARDED = 'FETCH_ALL_DISCARDED'
export const FETCH_DISCARDED_WITH_RANGE = 'FETCH_DISCARDED_WITH_RANGE'
export const FETCH_NET_PRICE_CHART_DATA = 'FETCH_NET_PRICE_CHART_DATA'
export const FETCH_DIESEL_DATA = 'FETCH_DIESEL_DATA'

export const documentReceived = (doc): RequestAction => ({ type: DOCUMENT_RECEIVED, payload: doc })

export const fetchAllProductData = (): RequestAction => ({
  type: FETCH_ALL_PRODUCT_DATA,
  request: {
    url: '/products',
    method: 'GET',
  },
})

export const fetchAllProductDataByUser = (id: string): RequestAction => ({
  type: FETCH_ALL_PRODUCT_DATA_BY_USER,
  request: {
    url: `/products/user/${id}`,
    method: 'GET',
  },
})

const fetchDocument = (userId: User['id'], docId: string, product: Product): RequestAction => ({
  type: FETCH_DOCUMENT,
  request: {
    url: `/products/docid/${docId}/userid/${userId}/product/${product}`,
    method: 'GET',
  },
})

const fetchDocument2 = (id: string, dispatch) => ({
  type: FETCH_DOCUMENT2,

  docId: id,
  dispatch,
})

const fetchMetadata = (id: string): RequestAction => ({
  type: FETCH_METADATA,
  request: {
    url: `/products/metadata/${id}`,
    method: 'GET',
  },
})

const fetchMovingAverages = (weeks: number, product: Product): RequestAction => ({
  type: FETCH_MOVING_AVERAGES,
  request: {
    url: `/products/${product}/movingaverages/${weeks}`,
    method: 'GET',
  },
})
const fetchUserAverages = (userId: string, weeks: number): RequestAction => ({
  type: FETCH_USER_AVERAGES,
  request: {
    url: `/products/user/${userId}/averages/${weeks}`,
    method: 'GET',
  },
})

const fetchGovStats = (weeks: number, product: Product): RequestAction => ({
  type: FETCH_GOVSTATS,
  request: {
    url: `/products/${product}/govstats/${weeks}`,
    method: 'GET',
  },
})
const fetchDetailedData = (userId: string): RequestAction => ({
  type: FETCH_DETAILED_DATA,
  request: {
    url: `/products/detaileddata/${userId}`,
    method: 'GET',
  },
})
const fetchDieselData = (userId: string, startDate: string, endDate: string): RequestAction => ({
  type: FETCH_DIESEL_DATA,
  request: {
    url: `/products/diesel/dieseldata/user/${userId}/start/${startDate}/end/${endDate}`,
  },
})

const fetchDetailedDataNEW = (
  userId: string,
  startDate: string,
  endDate: string,
  house: number,
  packeryFilter: Company,
  product: Product,
): RequestAction => ({
  type: FETCH_DETAILED_DATA_NEW,
  request: {
    url: `/products/${product}/detaileddata/start/${startDate}/end/${endDate}/packery/${packeryFilter}/house/${house}`,
    method: 'GET',
  },
})
const fetchSummaryData = (
  userId: string,
  start: string,
  end: string,
  packeryFilter: Company,
  houseId: number,
  product: Product,
): RequestAction => {
  return {
    type: FETCH_SUMMARY_DATA,
    request: {
      url: `/products/${product}/summarydata/user/${userId}/start/${start}/end/${end}/packery/${packeryFilter}/house/${houseId}`,
      method: 'GET',
    },
  }
}

const fetchLineChartData = (
  userId: string,
  start: string,
  end: string,
  packeryFilter: Company,
  houseId: number,
  product: Product,
  isLifeWeek: boolean,
): RequestAction => ({
  type: FETCH_LINECHART_DATA,
  request: {
    url: `/products/${product}/linechartdata/user/${userId}/start/${start}/end/${end}/packery/${packeryFilter}/house/${houseId}/`,
    method: 'GET',
  },
})
const fetchNetPriceChartData = (
  userId: string,
  start: string,
  end: string,
  packeryFilter: Company,
  houseId: number,
  product: Product,
): RequestAction => ({
  type: FETCH_NET_PRICE_CHART_DATA,
  request: {
    url: `/products/${product}/netpricechartdata/user/${userId}/start/${start}/end/${end}/packery/${packeryFilter}/house/${houseId}/`,
    method: 'GET',
  },
})

const fetchDiscarded = (
  userId: string,
  start: string,
  end: string,
  isLifeWeek: boolean,
): RequestAction => ({
  type: FETCH_DISCARDED,
  request: {
    url: `/products/eggs/discarded/user/${userId}/start/${start}/end/${end}/isLifeWeek/${isLifeWeek}`,
    method: 'GET',
  },
})

export const fetchAllDiscarded = (userId: string): RequestAction => ({
  type: FETCH_ALL_DISCARDED,
  request: { url: `/products/eggs/discarded/all/user/${userId}`, method: 'GET' },
})
export const fetchDiscardedWithRange = (userId: string): RequestAction => ({
  type: FETCH_DISCARDED_WITH_RANGE,
  request: { url: `/products/eggs/discarded/withrange/user/${userId}`, method: 'GET' },
})

export const postPDF = (data: FormData): RequestAction => ({
  type: POST_PDF,
  request: {
    url: `/products/receivePDF`,
    method: 'POST',
    headers: {
      'content-type': 'multipart/form-data',
    },
    data,
  },
})

export const createDocument = (data: any, product: Product, userId): RequestAction => {
  console.log({ data, product, userId })
  return {
    type: CREATE_DOCUMENT,
    request: {
      url: `/products/createdocument/product/${product}/userid/${userId}`,
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      data,
    },
  }
}

export const updateDocument = (data: any, product: Product, userId): RequestAction => {
  console.log({ data, product, userId })
  return {
    type: UPDATE_DOCUMENT,
    request: {
      url: `/products/updatedocument/product/${product}/userid/${userId}`,
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      data,
    },
  }
}

export const postAndUpdate = (
  data: FormData,
  uid: string,
  dispatch: any,
  setNumPendingCards: React.Dispatch<React.SetStateAction<number[]>>,
  setFileIsDuplicate: React.Dispatch<React.SetStateAction<boolean>>,
  setDuplicatedFiles: React.Dispatch<React.SetStateAction<string[]>>,
) => ({
  type: POST_AND_UPDATE,
  data,
  uid,
  dispatch,
  setNumPendingCards,
  setFileIsDuplicate,
  setDuplicatedFiles,
})

const deleteDocument = (uid: string, docid: string): RequestAction => ({
  type: DELETE_DOCUMENT,
  request: {
    url: `/products/user/${uid}/document/${docid}`,
    method: 'DELETE',
  },
})
const deleteWhitelistItem = (uid: string, email: string): RequestAction => ({
  type: DELETE_WHITELIST_ITEM,
  request: {
    url: `/users/deletewhitelistitem/userid/${uid}/email/${email}`,
    method: 'DELETE',
  },
})

const addWhitelistItem = (uid: string, data: any, dispatch: any) => ({
  type: ADD_WHITELIST_ITEM,
  uid,
  data,
  dispatch,
})

export const setCustomFilter = (
  uid: string,
  start: string,
  end: string,
  dispatch: any,
  caption: string,
) => ({
  type: SET_CUSTOM_FILTER,
  uid,
  start,
  end,
  dispatch,
  caption,
})
export const getCustomFilters = (uid: string) => ({
  type: GET_CUSTOM_FILTERS,
  request: {
    url: `/users/customfilters/userid/${uid}`,
    method: 'GET',
  },
})
export const deleteCustomFilter = (uid: string, filterId: string) => ({
  type: DELETE_CUSTOM_FILTER,
  request: {
    url: `/users/customfilters/userid/${uid}/filterid/${filterId}`,
    method: 'DELETE',
  },
  filterId,
})

const authActions = {
  fetchDieselData,
  fetchNetPriceChartData,
  fetchDiscardedWithRange,
  fetchAllDiscarded,
  fetchDiscarded,
  fetchAllProductData,
  fetchDocument,
  fetchMovingAverages,
  fetchUserAverages,
  fetchGovStats,
  fetchDetailedData,
  fetchDetailedDataNEW,
  fetchSummaryData,
  fetchLineChartData,
  fetchAllProductDataByUser,
  postPDF,
  postAndUpdate,
  deleteDocument,
  fetchMetadata,
  fetchDocument2,
  createDocument,
  updateDocument,
  addWhitelistItem,
  deleteWhitelistItem,
  setCustomFilter,
  getCustomFilters,
  deleteCustomFilter,
}

export default authActions
